import { useState, useEffect } from "react";

export default function useDebounce(delay, ...values) {
  const [debouncedValue, setDebouncedValue] = useState(values);

  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(values);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    },
    [...values]
  );

  return debouncedValue;
}



// WEBPACK FOOTER //
// ./app/hooks/useDebounce.js